<template>
  <div v-if="tickets.status">
    <div v-for="ticket in tickets.list" :key="ticket" class="mb-2">
      <C_Reg_Item :ticket="ticket" />
    </div>
  </div>
  <div v-else>
    ПУСТО
  </div>
</template>

<script>
import C_Reg_Item from "@/components/Dashboard/C_Reg_Item.vue";

export default {
  name: "C_Reg",
  components: {C_Reg_Item},
  props: ['tickets'],
  mounted() {

  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.progress-container:before {
  content: attr(data-text);
  position: absolute;
  left: 0;
  right: 0;
  top:0;
  font-size: 10px;
}

.progress-container {
  text-align: center;
  position: relative;
}
.is-success {
  color: black !important;
  font-size: 20px;
  background-color: transparent !important;
}

.out-of-time {
  animation-name: Blink;
  animation-iteration-count: infinite;
  animation-duration: 1000ms;
  animation-timing-function: ease-in-out;
}

@keyframes Blink {
  0% {
    background: inherit !important;
  }
  100% {
    background: #49b3ff !important;
  }
}

</style>